import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "./../services/authentication.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;

  constructor(
    public authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    console.log(this.authenticationService.userData);
    if (this.authenticationService.userData) {
      this.router.navigate(["dashboard"]);
    }
  }

  signUp() {
    this.authenticationService.SignUp(this.email, this.password);
    this.email = "";
    this.password = "";
  }

  signIn() {
    console.log(this);
    this.authenticationService
      .SignIn(this.email, this.password)
      .then(res => {
        console.log("Successfully signed in!");
        this.authenticationService.addHistory(
          "Signin with email: " + this.email
        );
        this.router.navigate(["dashboard"]);
      })
      .catch(err => {
        console.log("Something is wrong:", err.message);
      });
    this.email = "";
    this.password = "";
  }

  signOut() {
    this.authenticationService.SignOut();
  }
}
